import * as log from './log';
import config from '../config';

const PROVIDER_LIST_ID = 'contactlist_DBFCD89C-0F39-423D-A07F-3F16A68C36D4';
const CUSTOMER_LIST_ID = 'contactlist_2AC53ECA-0909-48AD-B32A-8750516C91B0';

/**
 * Add a new user to the Autopilot contact list
 *
 * @param {Object} user - the currently registered user
 *
 * @return {void}
 */
export async function addNewUser(user) {
  const { firstName, lastName, email, isPoolOwner, privateData } = user;
  const language = privateData && privateData.language;
  const listId = isPoolOwner ? PROVIDER_LIST_ID : CUSTOMER_LIST_ID;
  const { autopilotApiKey } = config;
  try {
    await fetch('https://api2.autopilothq.com/v1/contact', {
      method: 'POST',
      headers: {
        'autopilotapikey': autopilotApiKey,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        contact: {
          FirstName: firstName,
          LastName: lastName,
          Email: email,
          custom: { "string--Language": language},
        },
      }),
    });
    addToList(listId, email);
  } catch (e) {
    log.error(e, 'autopilot add fail');
  }
}

/**
 * Call Autopilot API to authenticate user
 *
 * @param {String} email - the email of the user
 *
 * @return {void}
 */
export async function associateEmail(email) {
  const { sessionId } = AutopilotAnywhere; // eslint-disable-line
  const { autopilotApiKey } = config;
  try {
    await fetch('https://api2.autopilothq.com/v1/pagevisit/associate', {
      method: 'POST',
      headers: {
        'autopilotapikey': autopilotApiKey,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ sessionId: sessionId, email: email }),
    });
  } catch (e) {
    log.error(e, 'autopilot associate fail');
  }
}

/**
 * Add a contact to the appropriate list
 *
 * @param {String} listId - the ID of the list
 * @param {String} email - the email of the user
 *
 * @return {void}
 */
export async function addToList(listId, email) {
  const url = `https://api2.autopilothq.com/v1/list/${listId}/contact/${email}`;
  const { autopilotApiKey } = config;
  try {
    await fetch(url, {
      method: 'POST',
      headers: {
        'autopilotapikey': autopilotApiKey,
      },
    });
  } catch (e) {
    log.error(e, 'autopilot add to list fail');
  }
}

/**
 * Add a contact to a specific journey
 *
 * @param {String} triggerId - Id of the trigger
 * @param {String} email - email of the user
 *
 * @return {void}
 */
export async function addToJourney(triggerId, email) {
  const shouldNotBeAdded = !triggerId || !email;
  if (shouldNotBeAdded) return null;

  const url = `https://api2.autopilothq.com/v1/trigger/${triggerId}/contact/${email}`;
  const { autopilotApiKey } = config;
  try {
    await fetch(url, {
      method: 'POST',
      headers: {
        'autopilotapikey': autopilotApiKey,
      },
    });
  } catch (e) {
    log.error(e, 'autopilot add to journey fail');
  }
}



// WEBPACK FOOTER //
// ./src/util/autopilot.js